import { useEffect, useRef } from 'react';

/**
 * Calls onIdle after `ms` with no pointer/key/touch activity.
 * `enabled` (default true — kiosk's original always-on behaviour is
 * unchanged) lets a caller gate the timer on runtime state, e.g. the
 * location-session re-lock only runs while a teacher is actively selected
 * (src/modules/location-session/components/LocationGate.tsx).
 */
export function useIdleReset(ms: number, onIdle: () => void, enabled = true): void {
  const cb = useRef(onIdle); cb.current = onIdle;
  useEffect(() => {
    if (!enabled) return;
    let timer = window.setTimeout(() => cb.current(), ms);
    const reset = () => { window.clearTimeout(timer); timer = window.setTimeout(() => cb.current(), ms); };
    const evts = ['pointerdown', 'keydown', 'touchstart'] as const;
    evts.forEach((e) => window.addEventListener(e, reset, { passive: true }));
    return () => { window.clearTimeout(timer); evts.forEach((e) => window.removeEventListener(e, reset)); };
  }, [ms, enabled]);
}
